import flags from "./flags.json";

export type FeatureFlagLane = "prod" | "staging";

// Fails this package's build if a hand edit drops a lane column. Type-only, so
// it never reaches the emitted .d.ts.
type AssertFlagTableShape<
  T extends Record<string, Record<FeatureFlagLane, boolean>>,
> = T;
type _FlagsShapeOk = AssertFlagTableShape<typeof flags>;

// The whole table, per lane. Edit flags.json by hand to change a value.
export const FEATURE_FLAGS = flags;

// Keyed off the exported const, NEVER off the `flags` import: keying off the
// import leaves a live `import ... from "./flags.json"` in the emitted
// dist/featureFlags/index.d.ts, and any consumer without resolveJsonModule then
// silently widens this to `string | number | symbol` under skipLibCheck.
export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

// Baked in by each app's vite config from the ENVIRONMENT build arg. Declared,
// never imported: `import.meta.env` cannot be used here because this package is
// also compiled to CommonJS (tsconfig_common.json) for its node consumers.
declare const __FLAG_ENV__: string | undefined;

// Anything that is not explicitly production runs the staging column: local
// dev, dev boxes and the staging lane all want the in-progress flags on. A
// missing define means a consumer with no bundler, where prod is the safe read.
const currentLane = (): FeatureFlagLane => {
  if (typeof __FLAG_ENV__ === "undefined") return "prod";
  // Compared rather than Array.includes: consumers of this package compile at
  // target es6 (marlin/libs/ts), where includes is not in lib.
  const raw = __FLAG_ENV__.trim().toLowerCase();
  return raw === "prod" || raw === "production" ? "prod" : "staging";
};

export class FeatureFlags {
  constructor(private readonly lane: FeatureFlagLane = currentLane()) {}

  public isFeatureEnabled(key: FeatureFlagKey): boolean {
    return FEATURE_FLAGS[key]?.[this.lane] ?? false;
  }
}
